import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui";

export const IsoLogo = (props: ComponentProps<typeof SvgSlot>) => (
  <SvgSlot {...props}>
    <svg viewBox="0 0 81 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.5432 0H60.9053L24.3621 71.7932H0L36.5432 0Z"
        fill="#F39C28"
      />
      <path
        d="M56.2673 25.0918H80.6294L44.0862 96.885H19.7241L56.2673 25.0918Z"
        fill="#F39C28"
      />
    </svg>
  </SvgSlot>
);
